var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.item.dt_aplicacao_br)+" "),_c('i',{class:_vm.item.meses != _vm.meses || _vm.item.dose_anterior == 1
        ? 'icofont-close-circled'
        : 'icofont-check-circled',style:({
      color: _vm.item.meses != _vm.meses || _vm.item.dose_anterior == 1 ? 'red' : 'green',
    })}),_c('br'),_vm._v(" com "+_vm._s(_vm.item.meses)+" meses "),(_vm.item.dose_anterior == 1)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",modifiers:{"hover":true,"right":true}}],staticClass:"icon-tooltip",attrs:{"title":"Dose registrada como transcrição de caderneta."}},[_c('i',{staticClass:"icofont-info-circle"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }